var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolDicomTagBrowser = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(4 5.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.739,
  cy: 1.739,
  r: 1.739
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.957 1.739H20"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.739,
  cy: 8.696,
  r: 1.739
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.957 8.696H20"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.739,
  cy: 15.652,
  r: 1.739
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.957 15.652H20"
})))));
export { SvgToolDicomTagBrowser as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-dicom-tag-browser.svg";